export const ROLES = {
    User: 'user',
    Manager: 'manager',
    Admin: 'admin'
}